<template>
    <div class="score-line-container">
        <div class="card-container" v-if="Status.LoadingCompleted">
            <div class="search-box">
                <el-button type="primary" icon="el-icon-plus" @click="showAddDialog">新增</el-button>
                <el-button type="success" icon="el-icon-upload" @click="showImportDialog">批量导入</el-button>
            </div>

            <div class="data-table">
                <el-table 
                    :data="List" 
                    border 
                    stripe
                    style="width: 100%"
                    :header-cell-style="{background:'#f5f7fa', color:'#606266', fontWeight: '600'}"
                    empty-text="暂无数据"
                    ref="table"
                    height="calc(100vh - 250px)"
                    @filter-change="handleFilterChange">
                    
                    <el-table-column label="操作" width="100" fixed="left" align="center">
                        <template slot-scope="{ row }">
                            <el-button type="text" size="small" @click="handleEdit(row)">编辑</el-button>
                        </template>
                    </el-table-column>

                    <el-table-column prop="Year" label="年份" width="80" align="center"></el-table-column>
                    
                    <el-table-column prop="Province" label="省份" width="150" align="center">
                        <template slot="header">
                            <span>省份</span>
                            <table-column-filter field="Province" :options="getFilters('Province')" :value="activeFilters['Province']" @filter-change="handleCustomFilter" />
                        </template>
                    </el-table-column>
                    
                    <el-table-column prop="Batch" label="批次" width="150" align="center">
                        <template slot="header">
                            <span>批次</span>
                            <table-column-filter field="Batch" :options="getFilters('Batch')" :value="activeFilters['Batch']" @filter-change="handleCustomFilter" />
                        </template>
                    </el-table-column>
                    
                    <el-table-column prop="Type" label="科类" width="120" align="center">
                        <template slot="header">
                            <span>科类</span>
                            <table-column-filter field="Type" :options="getFilters('Type')" :value="activeFilters['Type']" @filter-change="handleCustomFilter" />
                        </template>
                    </el-table-column>
                    
                    <el-table-column prop="Score" label="投档线（分）" width="150" align="center">
                        <template slot="header">
                            <span>投档线（分）</span>
                            <table-column-filter field="Score" :options="getFilters('Score')" :value="activeFilters['Score']" @filter-change="handleCustomFilter" />
                        </template>
                    </el-table-column>
                    
                    <el-table-column prop="Remark" label="备注" min-width="200" align="center"></el-table-column>
                </el-table>
            </div>
        </div>

        <!-- 新增/编辑对话框 -->
        <el-dialog :title="dialogTitle" :visible.sync="editDialogVisible" width="600px">
            <el-form :model="editForm" label-width="120px" :rules="editRules" ref="editForm">
                <el-form-item label="省份" prop="Province">
                    <el-select v-model="editForm.Province" placeholder="请选择省份" filterable style="width: 100%">
                        <el-option v-for="item in provinceOptions" :key="item" :label="item" :value="item"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="批次" prop="BatchName">
                    <el-select v-model="editForm.BatchName" placeholder="请选择批次" filterable style="width: 100%" @change="handleBatchChange">
                        <el-option v-for="item in batchOptions" :key="item.Name" :label="item.Name" :value="item.Name"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="科类" prop="TypeName">
                    <el-select v-model="editForm.TypeName" placeholder="请选择科类" filterable style="width: 100%" @change="handleTypeChange">
                        <el-option v-for="item in typeOptions" :key="item.Name" :label="item.Name" :value="item.Name"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="投档线（分）" prop="Score">
                    <el-input-number v-model="editForm.Score" :precision="2" :step="0.5" :min="0" :max="1000" style="width: 100%"></el-input-number>
                </el-form-item>
                <el-form-item label="备注">
                    <el-input v-model="editForm.Remark" type="textarea" :rows="3" placeholder="请输入备注"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="editDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="handleSave" :loading="saving">确 定</el-button>
            </span>
        </el-dialog>

        <!-- 批量导入对话框 -->
        <el-dialog title="批量导入投档线" :visible.sync="importDialogVisible" width="700px">
            <div class="info-box info">
                <i class="el-icon-info"></i>
                <div>
                    <p><strong>说明：</strong></p>
                    <ul>
                        <li>请下载Excel模板，按照模板格式填写投档线信息</li>
                        <li>模板包含字段：省份、批次、科类、投档线、备注</li>
                        <li>系统将自动导入，已存在的投档线将被跳过</li>
                    </ul>
                </div>
            </div>

            <div class="actions">
                <el-button type="success" icon="el-icon-download" @click="downloadTemplate">下载Excel模板</el-button>
            </div>

            <el-divider></el-divider>

            <el-form :model="importForm" label-width="120px">
                <el-form-item label="Excel文件">
                    <el-upload
                        class="upload-demo"
                        action="#"
                        :auto-upload="false"
                        :on-change="handleFileChange"
                        :on-remove="handleFileRemove"
                        :file-list="fileList"
                        accept=".xlsx,.xls"
                        :limit="1">
                        <el-button slot="trigger" size="small" type="primary">选择文件</el-button>
                        <div slot="tip" class="el-upload__tip">只能上传xlsx/xls文件</div>
                    </el-upload>
                </el-form-item>

                <el-form-item>
                    <el-button type="primary" @click="handleImportSubmit" :disabled="!uploadFile || importing" :loading="importing">
                        开始导入
                    </el-button>
                </el-form-item>
            </el-form>

            <div v-if="importResult" class="result-section">
                <el-divider>导入结果</el-divider>
                <div v-html="importResult" class="result-content"></div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { TYBM_Env } from '../../env.js';
import { TYBM_Tools } from '../../tools.js';
import TableColumnFilter from '../Shared/TableColumnFilter.vue';

export default {
    name: 'ScoreLine',
    components: {
        TableColumnFilter
    },
    inject: ['Loading', 'LoadingCompleted', 'getCurrentYear'],
    data() {
        return {
            Status: {
                LoadingCompleted: false
            },
            List: [],
            rawList: [],
            activeFilters: {},
            allFilters: {},
            
            // 字典选项
            provinceOptions: [
                '北京市', '天津市', '河北省', '山西省', '内蒙古自治区',
                '辽宁省', '吉林省', '黑龙江省', '上海市', '江苏省',
                '浙江省', '安徽省', '福建省', '江西省', '山东省',
                '河南省', '湖北省', '湖南省', '广东省', '广西壮族自治区',
                '海南省', '重庆市', '四川省', '贵州省', '云南省',
                '西藏自治区', '陕西省', '甘肃省', '青海省', '宁夏回族自治区',
                '新疆维吾尔自治区', '台湾省', '香港特别行政区', '澳门特别行政区'
            ],
            batchOptions: [],
            typeOptions: [],
            
            // 新增/编辑对话框
            editDialogVisible: false,
            dialogTitle: '新增投档线',
            editForm: {
                T_SN: null,
                Province: '',
                BatchCode: '',
                BatchName: '',
                TypeCode: '',
                TypeName: '',
                Score: null,
                Remark: ''
            },
            editRules: {
                Province: [{ required: true, message: '请选择省份', trigger: 'change' }],
                BatchName: [{ required: true, message: '请选择批次', trigger: 'change' }],
                TypeName: [{ required: true, message: '请选择科类', trigger: 'change' }],
                Score: [{ required: true, message: '请输入投档线', trigger: 'blur' }]
            },
            saving: false,
            
            // 批量导入
            importDialogVisible: false,
            importForm: {},
            fileList: [],
            uploadFile: null,
            importing: false,
            importResult: ''
        };
    },
    methods: {
        getFilters(prop) {
            if (this.allFilters[prop]) {
                return this.allFilters[prop].map(opt => ({ text: opt.Label, value: opt.Value }));
            }
            if (!this.rawList || this.rawList.length === 0) return [];
            const values = new Set();
            this.rawList.forEach(row => {
                const val = row[prop];
                if (val !== null && val !== undefined && val !== '') {
                    values.add(val);
                }
            });
            return Array.from(values).sort().map(val => ({ text: val, value: val }));
        },
        handleCustomFilter({ field, values }) {
            if (values && values.length > 0) {
                this.$set(this.activeFilters, field, values);
            } else {
                this.$delete(this.activeFilters, field);
            }
            this.applyFilters();
        },
        applyFilters() {
            let result = this.rawList;
            
            Object.keys(this.activeFilters).forEach(key => {
                const values = this.activeFilters[key];
                if (values && values.length > 0) {
                    result = result.filter(row => values.includes(row[key]));
                }
            });
            
            this.List = result;
            
            this.$nextTick(() => {
                if (this.$refs.table) {
                    this.$refs.table.doLayout();
                }
            });
        },
        handleFilterChange() {
            this.$nextTick(() => {
                if (this.$refs.table) {
                    this.$refs.table.doLayout();
                }
            });
        },
        loadDictData() {
            const that = this;
            
            // 加载批次
            const batchApi = '/Dict/GetDictList';
            const batchUrl = TYBM_Env.GetApiUrl(batchApi) + '?type=PC';
            TYBM_Tools.AxiosGetEx(that, batchApi, batchUrl, { loading: false })
                .then(result => {
                    that.batchOptions = result.data.map(item => ({ Code: item.BeiZhu2, Name: item.Name }));
                });
            
            // 加载科类
            const typeApi = '/Dict/GetDictList';
            const typeUrl = TYBM_Env.GetApiUrl(typeApi) + '?type=KL';
            TYBM_Tools.AxiosGetEx(that, typeApi, typeUrl, { loading: false })
                .then(result => {
                    that.typeOptions = result.data.map(item => ({ Code: item.BeiZhu2, Name: item.Name }));
                });
        },
        loadData() {
            const that = this;
            const api_name = '/Public/GetScoreLineList';
            const url = TYBM_Env.GetApiUrl(api_name);

            TYBM_Tools.AxiosGetEx(that, api_name, url, { loading_msg: '正在加载数据' })
                .then(result => {
                    that.rawList = result.data.List;
                    that.allFilters = result.data.AllFilters || {};
                    that.applyFilters();
                    that.Status.LoadingCompleted = true;
                })
                .catch(() => {
                    that.$message.error('加载数据失败');
                });
        },
        showAddDialog() {
            this.dialogTitle = '新增投档线';
            this.editForm = {
                T_SN: null,
                Province: '',
                BatchCode: '',
                BatchName: '',
                TypeCode: '',
                TypeName: '',
                Score: null,
                Remark: ''
            };
            this.editDialogVisible = true;
            this.$nextTick(() => {
                if (this.$refs.editForm) {
                    this.$refs.editForm.clearValidate();
                }
            });
        },
        handleEdit(row) {
            this.dialogTitle = '编辑投档线';
            this.editForm = {
                T_SN: row.T_SN,
                Province: row.Province,
                BatchCode: '',
                BatchName: row.Batch,
                TypeCode: '',
                TypeName: row.Type,
                Score: row.Score,
                Remark: row.Remark
            };
            this.editDialogVisible = true;
            this.$nextTick(() => {
                if (this.$refs.editForm) {
                    this.$refs.editForm.clearValidate();
                }
            });
        },
        handleBatchChange(val) {
            const batch = this.batchOptions.find(item => item.Name === val);
            if (batch) {
                this.editForm.BatchCode = batch.Code || '';
            }
        },
        handleTypeChange(val) {
            const type = this.typeOptions.find(item => item.Name === val);
            if (type) {
                this.editForm.TypeCode = type.Code || '';
            }
        },
        handleSave() {
            const that = this;
            that.$refs.editForm.validate(valid => {
                if (!valid) return;
                
                that.saving = true;
                const api_name = that.editForm.T_SN ? '/Public/UpdateScoreLine' : '/Public/AddScoreLine';
                const url = TYBM_Env.GetApiUrl(api_name);
                const data = {
                    T_SN: that.editForm.T_SN,
                    Province: that.editForm.Province,
                    BatchCode: that.editForm.BatchCode,
                    BatchName: that.editForm.BatchName,
                    TypeCode: that.editForm.TypeCode,
                    TypeName: that.editForm.TypeName,
                    Score: that.editForm.Score,
                    Remark: that.editForm.Remark
                };
                
                TYBM_Tools.AxiosPostEx(that, api_name, url, data, { loading: false })
                    .then(() => {
                        that.$message.success(that.editForm.T_SN ? '修改成功' : '添加成功');
                        that.editDialogVisible = false;
                        that.loadData();
                    })
                    .finally(() => {
                        that.saving = false;
                    });
            });
        },
        showImportDialog() {
            this.importDialogVisible = true;
            this.fileList = [];
            this.uploadFile = null;
            this.importResult = '';
        },
        downloadTemplate() {
            window.open('/GXZS/Template/v1投档线导入模板.xls', '_blank');
        },
        handleFileChange(file) {
            this.uploadFile = file.raw;
        },
        handleFileRemove() {
            this.uploadFile = null;
        },
        handleImportSubmit() {
            const that = this;
            const api_name = '/Public/ImportScoreLine';
            const data = { "RarFile": that.uploadFile };
            const url = TYBM_Env.GetApiUrl(api_name);
            
            that.importing = true;
            TYBM_Tools.AxiosUploadFile(that, api_name, url, data, { loading_msg: '正在处理', has_progress: true })
                .then(result => {
                    that.importResult = result.data.Msg;
                    that.$message.success('导入完成');
                    that.loadData();
                })
                .catch(() => {
                    that.$message.error('导入失败');
                })
                .finally(() => {
                    that.importing = false;
                });
        },
        onYearChange() {
            this.loadData();
        }
    },
    created() {
        this.$root.$on('global-year-change', this.onYearChange);
    },
    beforeDestroy() {
        this.$root.$off('global-year-change', this.onYearChange);
    },
    mounted() {
        this.loadDictData();
        this.loadData();
    }
};
</script>

<style scoped>
.score-line-container {
    width: 100%;
}

.search-box {
    display: flex;
    gap: 12px;
    margin-bottom: 20px;
    align-items: center;
}

.data-table {
    background: white;
    border-radius: 8px;
    overflow-x: auto;
}

.data-table >>> .el-table {
    font-size: 13px;
}

.data-table >>> .el-table th,
.data-table >>> .el-table td {
    padding: 0 !important;
    height: 40px !important;
}

.data-table >>> .el-table th {
    background-color: #f5f7fa !important;
    color: #606266;
    font-weight: 600;
}

.data-table >>> .el-table__row {
    height: 40px !important;
}

.data-table >>> .el-table__row:hover {
    background-color: #f5f9ff;
}

.data-table >>> .el-table .cell {
    padding: 0 8px !important;
    white-space: nowrap !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    line-height: 40px !important;
}

.data-table >>> .el-table th > .cell {
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    height: 100% !important;
    line-height: normal !important;
}

.data-table >>> .el-button--text {
    color: #409EFF;
    padding: 0;
}

.data-table >>> .el-button--text:hover {
    color: #66b1ff;
}

.info-box {
    padding: 16px;
    border-radius: 4px;
    margin-bottom: 24px;
    border-left: 4px solid #1890ff;
    background-color: #e6f7ff;
    color: #0050b3;
    display: flex;
    gap: 12px;
}

.info-box i {
    font-size: 20px;
    margin-top: 2px;
}

.info-box ul {
    margin: 8px 0 0 20px;
}

.actions {
    margin-bottom: 20px;
}

.result-section {
    margin-top: 20px;
}

.result-content {
    padding: 15px;
    background-color: #f5f7fa;
    border-radius: 4px;
    border: 1px solid #e4e7ed;
    max-height: 300px;
    overflow-y: auto;
}

.upload-demo >>> .el-upload {
    display: inline-block;
}

.upload-demo >>> .el-upload input[type="file"] {
    display: none !important;
}
</style>

